// Felles formaterings- og statushjelparar (nynorsk)

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(String(iso).length <= 10 ? `${iso}T00:00:00` : iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}.${d.getFullYear()}`;
};

/** dd.mm.yyyy HH:MM (lokal tid) – for loggar og tidsstempel. */
export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(iso)} ${hh}:${mi}`;
};

export const todayISO = () => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};

export const STATUS_LABEL = {
  ok: "OK",
  upcoming: "Nærmar seg",
  overdue: "Forfalt",
};

export const daysText = (days) => {
  if (days === null || days === undefined) return "";
  if (days === 0) return "i dag";
  if (days < 0) return `${Math.abs(days)} dagar sidan`;
  return `om ${days} dagar`;
};

export const hoursText = (hrs) => {
  if (hrs === null || hrs === undefined) return "";
  if (hrs <= 0) return `${Math.abs(hrs)} t over`;
  return `${hrs} t att`;
};

export const kindLabel = (k) => (k === "annual" ? "Årskontroll" : "Service");

export const CATEGORY_LABEL = { filter: "Filter", olje: "Olje", kjolevaeske: "Kjølevæske", anna: "Anna" };
export const CATEGORY_OPTIONS = [
  { value: "filter", label: "Filter" },
  { value: "olje", label: "Olje" },
  { value: "kjolevaeske", label: "Kjølevæske" },
  { value: "anna", label: "Anna" },
];

export const CUSTOMER_TYPE_LABEL = { serviceavtale: "Serviceavtale", engangskunde: "Engangskunde" };

export const REPORT_TYPE_LABEL = { service: "Servicerapport", jobb: "Jobbrapport" };

export const USER_TITLES = ["Mekaniker", "Tekniker", "Servicetekniker", "Dagleg leiar", "Administrator"];

export const num = (v) =>
  v === null || v === undefined || v === "" ? "—" : Number(v).toLocaleString("nb-NO");

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
